import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: '[app-users-list]',
  templateUrl: './users-list.component.html',
  styleUrls: ['./users-list.component.css']
})
export class UsersListComponent implements OnInit {

  @Input() users: any;
  @Input() filialId: any;
  @Input() userType: any;
  @Input() selectedUser: any;
  @Output() showUser = new EventEmitter();
  @Output('onDelete') delete = new EventEmitter();
  @Output('onSeeFilials') seeFilials = new EventEmitter();
  @Output('onSeeInventars') seeInventars = new EventEmitter();
  @Output() onUnassign = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  onShowUser(user) {
    this.showUser.emit(user);
  }

  onDelete(user) {
    this.delete.emit(user);
  }

  onSeeFilials(user) {
    this.seeFilials.emit(user);
  }

  onSeeInventars(user) {
    this.seeInventars.emit(user);
  }
}
